export default function AceptarPedidoButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="text-white font-semibold flex items-center justify-center gap-2 flex-1 min-w-0 h-12 px-4 rounded-full transition-all duration-200 ease-out active:scale-[0.98] hover:brightness-110"
      style={{
        backgroundColor: '#0071e3',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontFamily: '"Public Sans", sans-serif',
        letterSpacing: '-0.01em',
        minWidth: 'max-content',
        whiteSpace: 'nowrap',
      }}
    >
      Aceptar
    </button>
  );
}
